import { create } from "zustand";

const useDeleteModal = create((set) => ({
  isOpen: false,
  config: null, // holds endpoint, payload, messages

  open: (config) => set({ isOpen: true, config }), 
  close: () => set({ isOpen: false, config: null }),
}));

export default useDeleteModal;
